import React, { Component } from 'react';
import { connect } from 'react-redux';
import EnterpriseSidebar from 'components/admin/sidebar/EnterpriseSidebar';
import { Redirect, Route, Switch } from 'react-router-dom';
import WorkOrdersContainer from './work-orders/WorkOrdersContainer';
import ContractorsContainer from './contractors/ContractorsContainer';
import BuildingsContainer from './buildings/BuildingsContainer';
import {
  getCurrentUser,
  hasEnterpriseRedirect,
} from '../../selectors/authentication';
import { usersUtil, ROLES, TYPES } from '../../services/utils/users-util';
import './Admin.css';
import ClientsContainer from './clients/ClientsContainer';
import ServiceProvidersContainer from 'components/admin/service-providers/ServiceProvidersContainer';
import { ConditionRoute } from '../shared/ConditionRoute';
import Quotes from './quotes/Quotes';
import TasksContainer from './tasks/TasksContainer';
import {
  getActiveRoute,
  getHideSidebar,
} from 'selectors/admin/sidebar/sidebar';
import { selectRoute, setHideSideBar } from 'actions/admin/sidebar/sidebar';
import InvoicesContainer from './invoices/InvoicesContainer';
import TeamContainer from './team/TeamContainer';
import Users from './users/Users';
import Tutorials from './tutorials/Tutorials';
import { PermissionsUtil } from 'services/utils/permissions-util';
import ContractorsInvoices from 'components/admin/contractors-invoices/ContractorsInvoices';
import ReportsContainer from 'components/admin/reports/ReportsContainer';
import PurchaseOrdersContainer from 'components/admin/purchase-orders/PurchaseOrdersContainer';
import { simpleScrollToTop } from 'services/utils/scroller-util';
import SurveysContainer from 'components/admin/surveys/SurveysContainer';
import { loadContractorRequest } from 'actions/admin/contractors/contractors';
import { getCurrentContractor } from 'selectors/admin/contractors/contractors';
import { goToEditContractor } from 'actions/admin/team/contractor-team';
import ProjectsContainer from 'components/admin/projects/ProjectsContainer';
import GeneralContractorsContainer from 'components/admin/general-contractors/GeneralContractorsContainer';
import DashboardContainer from 'components/admin/dashboard/DashboardContainer';
import { getCurrentGeneralContractor } from 'components/admin/general-contractors/store/selectors';
import {
  loadGeneralContractorRequest,
  showOnboarding,
} from 'components/admin/general-contractors/store/actions';
import { Enterprise } from 'domain/enterprise';
import TermsModal from 'components/shared/modal/TermsModal';
import { updateTermsAndConditions } from 'actions/admin/users/users';
import ConfirmationModal from 'components/shared/modal/ConfirmationModal';
import {
  enterpriseRedirect,
  cancelEnterpriseRedirect,
} from 'actions/authentication';

class Admin extends Component {
  constructor(props) {
    super(props);

    props.dispatch(setHideSideBar(false));

    this.userIsSpackleAdmin = false; //usersUtil.isSpackleAdmin(props.currentUser);
    this.userIsAdmin = usersUtil.isAdmin(props.currentUser);
    this.adminUserCanSeeMoney = PermissionsUtil.adminUserCanSeeMoney(
      props.currentUser
    );
    this.userIsGC = usersUtil.hasType(
      props.currentUser,
      TYPES.GENERAL_CONTRACTOR
    );
    this.userIsClient = usersUtil.hasType(props.currentUser, TYPES.CLIENT);
    this.userIsContractor = usersUtil.hasType(
      props.currentUser,
      TYPES.CONTRACTOR
    );
    this.defaultRoute = '/dashboard';
    this.showEnterpriseActions = Enterprise.showActions(props.currentUser);

    this.sidebarItems = [
      {
        label: 'Work Orders',
        route: '/work-orders',
        icon: 'work-orders',
        show:
          this.userIsAdmin ||
          this.userIsClient ||
          this.userIsContractor ||
          this.userIsGC,
        type: 'service-work',
      },
      {
        label: 'Tasks',
        route: '/tasks',
        icon: 'tasks',
        show: this.userIsAdmin || this.userIsGC,
        type: 'service-work',
      },
      {
        label: 'Clients',
        route: '/clients',
        icon: 'clients',
        show: this.showEnterpriseActions,
        type: 'shared-bottom',
      },
      {
        label: 'Service Providers',
        route: '/service-providers',
        icon: 'service-providers',
        show: this.showEnterpriseActions,
        type: 'shared-bottom',
      },
      {
        label: 'Sub Contractors',
        route: '/contractors',
        icon: 'contractors',
        show: this.userIsAdmin || this.userIsGC,
        type: 'shared-bottom',
      },
      {
        label: 'Buildings',
        route: '/buildings',
        icon: 'buildings',
        show: this.userIsAdmin || this.userIsClient || this.userIsGC,
        type: 'shared-bottom',
      },
      {
        label: 'Purchase Orders',
        route: '/purchase-orders',
        icon: 'purchase-orders',
        show: PermissionsUtil.showPurchaseOrders(props.currentUser),
        type: 'service-work',
      },
      {
        label: 'Quotes',
        route: '/quotes',
        icon: 'quotes',
        show: this.adminUserCanSeeMoney || this.userIsGC,
        type: 'service-work',
      },
      {
        label: 'Surveys',
        route: '/surveys',
        icon: 'surveys',
        show: PermissionsUtil.showSurveys(props.currentUser),
        type: 'service-work',
      },
      {
        label: 'Invoices',
        route: '/invoices',
        icon: 'invoices',
        show: this.adminUserCanSeeMoney || this.userIsClient || this.userIsGC,
        type: 'service-work',
      },
      {
        label:
          this.userIsAdmin || this.userIsGC
            ? 'Contractors Invoices'
            : 'Invoices',
        route: '/contractors-invoices',
        icon: 'contractors-invoices',
        show: this.userIsAdmin || this.userIsContractor || this.userIsGC,
        type: 'service-work',
      },
      {
        label: 'Reports',
        route: '/reports',
        icon: 'reports',
        show:
          usersUtil.hasRole(props.currentUser, ROLES.SPACKLE_ADMIN) ||
          usersUtil.hasRole(props.currentUser, ROLES.BUSINESS_DEVELOPMENT) ||
          this.userIsContractor ||
          this.userIsGC,
        type: 'service-work',
      },
      {
        label: 'Team',
        route: '/team',
        icon: 'team',
        show: PermissionsUtil.hasPermissionTeamPage(props.currentUser),
        type: 'shared-bottom',
      },
      {
        label: 'Users',
        route: '/users',
        icon: 'users',
        show: usersUtil.hasRole(props.currentUser, ROLES.SPACKLE_ADMIN),
        type: 'shared-bottom',
      },
      {
        label: 'Projects',
        route: '/projects',
        icon: 'projects',
        show: true,
        type: 'enterprise',
      },
      {
        label: 'General Contractors',
        route: '/general-contractors',
        icon: 'general-contractors',
        show: this.userIsAdmin,
        type: 'enterprise',
      },
      {
        label: 'Reports',
        route: '/spe-reports',
        icon: 'spe-reports',
        show: this.showEnterpriseActions,
        type: 'enterprise',
      },
      {
        label: 'Tutorials',
        route: '/tutorials',
        icon: 'tutorials',
        show: true,
        type: 'shared-bottom',
      },
      {
        label: 'Dashboard',
        route: '/dashboard',
        icon: 'dashboard',
        show: true,
        type: 'shared-top',
      },
    ];
  }

  UNSAFE_componentWillMount() {
    const user = this.props.currentUser;
    if (!user.terms_of_service) {
      this.setState({ showTerms: true });
    }
    if (
      this.userIsContractor &&
      user.accountable &&
      !user.accountable.confirmed
    ) {
      this.props
        .dispatch(loadContractorRequest(user.accountable_id))
        .then(() => this.redirectToTeamEditPage());
    } else if (
      this.userIsGC &&
      user.accountable &&
      !user.accountable.confirmed
    ) {
      this.props
        .dispatch(loadGeneralContractorRequest(user.accountable_id))
        .then(() => this.redirectToGeneralContractorOnboarding());
    }
  }

  redirectToTeamEditPage = () => {
    if (this.props.contractor && !this.props.contractor.confirmed) {
      this.props.dispatch(goToEditContractor());
    }
  };

  redirectToGeneralContractorOnboarding = () => {
    if (
      this.props.generalContractor &&
      !this.props.generalContractor.confirmed
    ) {
      this.props.dispatch(setHideSideBar(true));
      this.props.dispatch(showOnboarding());
    }
  };

  handleItemSelected = (id) => {
    simpleScrollToTop();
    this.props.dispatch(
      selectRoute(
        id,
        this.props.match.url +
          this.sidebarItems.find((element) => element.icon === id).route
      )
    );
  };

  handleGenerateLink = (id) => {
    return `${this.props.match.url}/${id}`;
  };

  onTermsAccept = () => {
    this.props.dispatch(updateTermsAndConditions(true)).then((response) => {
      if (response.ok) {
        this.setState((state) => ({ showTerms: !state.showTerms }));
      }
    });
  };

  handleEnterpriseRedirect = (redirect) => {
    this.props.dispatch(
      redirect ? enterpriseRedirect() : cancelEnterpriseRedirect()
    );
  };

  render() {
    return (
      <div className="admin">
        <div
          className={`admin-col sidebar-container ${
            this.props.hideSideBar ? 'hidden' : ''
          }`}
        >
          <EnterpriseSidebar
            sharedItemsTop={this.sidebarItems
              .filter((item) => item.type === 'shared-top')
              .map((item) => {
                return {
                  ...item,
                  selected: item.icon === this.props.activeRoute,
                };
              })}
            serviceWorkItems={this.sidebarItems
              .filter((item) => item.type === 'service-work')
              .map((item) => {
                return {
                  ...item,
                  selected: item.icon === this.props.activeRoute,
                };
              })}
            enterpriseItems={this.sidebarItems
              .filter((item) => item.type === 'enterprise')
              .map((item) => {
                return {
                  ...item,
                  selected: item.icon === this.props.activeRoute,
                };
              })}
            sharedItemsBottom={this.sidebarItems
              .filter((item) => item.type === 'shared-bottom')
              .map((item) => {
                return {
                  ...item,
                  selected: item.icon === this.props.activeRoute,
                };
              })}
            onItemSelected={this.handleItemSelected}
            onGenerateLink={this.handleGenerateLink}
          />
        </div>
        <div id="admin-col-item-container" className="admin-col item-container">
          {!this.props.currentUser.terms_and_conditions && (
            <TermsModal
              show={this.state.showTerms}
              onHide={this.onTermsAccept}
            />
          )}
          {this.props.hasEnterpriseRedirect && (
            <ConfirmationModal
              show={this.props.hasEnterpriseRedirect}
              message="Spackle Enterprise for construction project management, is now called 360Plus. Would you like to be directed there?"
              onHide={this.handleEnterpriseRedirect}
            />
          )}
          <Switch>
            <Route
              path={`${this.props.match.url}/work-orders`}
              component={WorkOrdersContainer}
            />

            <ConditionRoute
              path={`${this.props.match.url}/contractors`}
              component={ContractorsContainer}
              show={this.userIsAdmin || this.userIsGC}
            />

            <ConditionRoute
              path={`${this.props.match.url}/buildings`}
              component={BuildingsContainer}
              show={
                this.userIsAdmin ||
                usersUtil.hasType(this.props.currentUser, TYPES.CLIENT) ||
                this.userIsGC
              }
            />

            <ConditionRoute
              path={`${this.props.match.url}/clients`}
              component={ClientsContainer}
              show={this.showEnterpriseActions}
            />

            <ConditionRoute
              path={`${this.props.match.url}/service-providers`}
              component={ServiceProvidersContainer}
              show={this.showEnterpriseActions}
            />

            <ConditionRoute
              path={`${this.props.match.url}/quotes`}
              component={Quotes}
              show={this.userIsAdmin || this.userIsGC}
            />

            <ConditionRoute
              path={`${this.props.match.url}/tasks`}
              component={TasksContainer}
              show={this.userIsAdmin || this.userIsGC}
            />

            <ConditionRoute
              path={`${this.props.match.url}/purchase-orders`}
              component={PurchaseOrdersContainer}
              show={PermissionsUtil.showPurchaseOrders(this.props.currentUser)}
            />

            <ConditionRoute
              path={`${this.props.match.url}/invoices`}
              component={InvoicesContainer}
              show={
                this.adminUserCanSeeMoney ||
                usersUtil.hasType(this.props.currentUser, TYPES.CLIENT) ||
                this.userIsGC
              }
            />

            <ConditionRoute
              path={`${this.props.match.url}/team`}
              component={TeamContainer}
              show={PermissionsUtil.hasPermissionTeamPage(
                this.props.currentUser
              )}
            />

            <ConditionRoute
              path={`${this.props.match.url}/users`}
              component={Users}
              show={usersUtil.hasRole(
                this.props.currentUser,
                ROLES.SPACKLE_ADMIN
              )}
            />

            <ConditionRoute
              path={`${this.props.match.url}/contractors-invoices`}
              component={ContractorsInvoices}
              show={
                this.userIsAdmin ||
                usersUtil.hasType(this.props.currentUser, TYPES.CONTRACTOR) ||
                this.userIsGC
              }
            />

            <ConditionRoute
              path={`${this.props.match.url}/reports`}
              component={ReportsContainer}
              show={
                usersUtil.hasRole(
                  this.props.currentUser,
                  ROLES.SPACKLE_ADMIN
                ) ||
                usersUtil.hasRole(
                  this.props.currentUser,
                  ROLES.BUSINESS_DEVELOPMENT
                ) ||
                usersUtil.hasType(this.props.currentUser, TYPES.CONTRACTOR) ||
                this.userIsGC
              }
            />

            <ConditionRoute
              path={`${this.props.match.url}/surveys`}
              component={SurveysContainer}
              show={PermissionsUtil.showSurveys(this.props.currentUser)}
            />

            <ConditionRoute
              path={`${this.props.match.url}/projects`}
              component={ProjectsContainer}
              show={true}
            />

            <ConditionRoute
              path={`${this.props.match.url}/general-contractors`}
              component={GeneralContractorsContainer}
              show={this.userIsAdmin || this.userIsGC}
            />

            <ConditionRoute
              path={`${this.props.match.url}/spe-reports`}
              component={ReportsContainer}
              show={this.showEnterpriseActions}
            />

            <ConditionRoute
              path={`${this.props.match.url}/tutorials`}
              component={Tutorials}
              show={true}
            />

            <ConditionRoute
              path={`${this.props.match.url}/dashboard`}
              component={DashboardContainer}
              show={true}
            />

            <Redirect to={this.props.match.url + this.defaultRoute} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default connect((state) => {
  return {
    activeRoute: getActiveRoute(state),
    currentUser: getCurrentUser(state),
    contractor: getCurrentContractor(state),
    generalContractor: getCurrentGeneralContractor(state),
    hideSideBar: getHideSidebar(state),
    hasEnterpriseRedirect: hasEnterpriseRedirect(state),
  };
})(Admin);



// WEBPACK FOOTER //
// ./src/components/admin/Admin.js